import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import styles from './styles';
import Typography from 'material-ui/Typography';

class Footer extends Component {
  render(){
    const { classes, theme } = this.props;
    return(
      <div value="flex-end" className={classes.footer}>
        <Typography type="body1" color="black" noWrap className={classes.textFontSize}>
        
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Footer);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/Footer/index.js